import { render, staticRenderFns } from "./BatteryFile.vue?vue&type=template&id=f03f74c2&scoped=true&"
import script from "./BatteryFile.vue?vue&type=script&lang=js&"
export * from "./BatteryFile.vue?vue&type=script&lang=js&"
import style0 from "./BatteryFile.vue?vue&type=style&index=0&id=f03f74c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03f74c2",
  null
  
)

export default component.exports